// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ProjectTemplatesUpdateSchema = z.object({
  project_template: z.object({
    name: z.coerce.string().max(255).nullish(),
    description: z.coerce.string().max(1024).nullish(),
    auto_create_on_new_client: z.boolean().nullish(),
    add_all_users: z.boolean().nullish(),
    color: z.coerce.string().max(6).nullish(),
    rate_type: z.coerce.string().nullish(),
    hour_rate: z.number().nullish(),
    required_notes: z.boolean().nullish(),
    enable_labels: z.coerce.string().nullish(),
    required_labels: z.boolean().nullish(),
    allow_only_one_tag: z.boolean().nullish(),
    label_ids: z.optional(z.array(z.unknown())),
    required_label_ids: z.optional(z.array(z.unknown())),
    trigger_source: z.coerce.string().nullish(),
  }),
});
